import Core from '../plugin-core-system/core.class.js';
import Focus from '../helper/focus.helper.js';

export default class CsFormFields extends Core {

    static options = {};

    /**
     * init select form fields with plugin library select2
     */
    initSelect() {
        const selectElements = this.el.querySelectorAll('.js-select');

        if (selectElements.length) {
            selectElements.forEach((element) => {
                // eslint-disable-next-line
                jQuery(element).selectWoo({
                    placeholder: element.dataset.placeholder,
                    minimumResultsForSearch: -1
                });
            });
        }
    }

    /**
     * init custom file upload
     */
    initFileUpload() {
        const fileUploadElements = this.el.querySelectorAll('.js-file-upload');

        if (fileUploadElements.length) {
            fileUploadElements.forEach((element) => {

                const inputFile = element.querySelector('.js-file-upload-input');

                // trigger upload on space & enter = default button functionality
                element.addEventListener('keydown', function (e) {
                    if (e.which === 32 || e.which === 13) {
                        e.preventDefault();
                        inputFile.click();
                    }
                });

                // change file name for text input
                inputFile.addEventListener('change', (e) => {
                    const filename = e.target.value.split('\\').pop();
                    const filenameInput = element.querySelector('.js-file-upload-filename');
                    filenameInput.value = filename;
                    filenameInput.placeholder = filename;
                    Focus.setFocusToElement(filenameInput);
                });
            });
        }
    }

    initCountrySelect() {
      const countryWraps = this.el.querySelectorAll('.js-select-country-wrapper');

      if (countryWraps.length) {

        const allSelects = this.el.querySelectorAll(
          '.js-select-country-wrapper .js-select-country, ' +
          '.powermail_fieldwrap_type_select.hide-in-brazil .js-select'
        );

        allSelects.forEach(select => {
          // eslint-disable-next-line
          jQuery(select).on('change', function() {
            const searchField = this.parentElement.querySelector('.select2-search--inline .select2-search__field');
            if (searchField) {
              searchField.placeholder = this.dataset.placeholderAlt || this.dataset.placeholder;
            }
          });
        });

        // Lateinamerika-spezifische Logik
        const latinAmericaSelects = this.el.querySelectorAll('.powermail_fieldwrap_lateinamerikalaender .js-select-country');

        latinAmericaSelects.forEach(select => {
          // eslint-disable-next-line
          jQuery(select).on('select2:select', (evt) => {
            this.toggleSelectField(evt.params.data.id, true);
          });

          // eslint-disable-next-line
          jQuery(select).on('select2:unselect', (evt) => {
            this.toggleSelectField(evt.params.data.id, false);
          });
        });
      }
    }

    toggleSelectField(countryId, show) {
      const fieldset = document.querySelector('.powermail_fieldset');
      if (!fieldset) return;

      const label = fieldset.querySelector(`label[title="${countryId}"]`);
      const wrapper = label?.closest('.powermail_fieldwrap_type_select');

      if (!wrapper) return;

      if (show) {
        wrapper.style.display = 'block';
      } else {
        const targetSelect = wrapper.querySelector('.js-select');
        if (targetSelect) {
          targetSelect.value = '';
          targetSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }
        wrapper.style.display = 'none';
      }
    }

    toggleStrongLabel() {
      const form = document.querySelector('form.powermail_form_1');
      if (!form) return;

      form.querySelectorAll('label[title]:not([title=""])').forEach(label => {
        const title = label.getAttribute('title');
        if (title) {
          const regex = new RegExp(`(${title})`, 'g');
          label.innerHTML = label.innerHTML.replace(regex, '<b>$1</b>');
        }
      });
    }

    prefillPageTitle() {
      const pageTitleField = document.querySelector('form.powermail_form #powermail_field_pagetitle');
      if (!pageTitleField) return;

      if (window.location.href.includes('/reise-anfrage/')) {
        const rawBookmarks = localStorage.getItem('cs_bookmarks');

        if (rawBookmarks) {
          try {
            const bookmarks = JSON.parse(rawBookmarks);
            let value = '';

            bookmarks.booked.forEach(item => {
              value += item.title + ', ';
            });

            if (value) {
              pageTitleField.value = value;
              pageTitleField.readOnly = true;
            }
          } catch (e) {
            console.error('Error parsing bookmarks:', e);
          }
        }
      } else {
        const h1Element = document.querySelector('h1');
        if (h1Element) {
          pageTitleField.value = h1Element.textContent.trim();
          pageTitleField.readOnly = true;
        }
      }
    }

    init() {
        this.initSelect();
        this.initFileUpload();
        this.initCountrySelect();
        this.toggleStrongLabel();
        this.prefillPageTitle();
    }
}
